export default __webpack_public_path__ + "static/media/florence.ddbeced0.jpg";